export default "__VITE_ASSET__caO13qHW__"